import {
  Card,
  Skeleton,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';

type Props = {
  id: string;
  label: string;
  value?: string;
  isLoading?: boolean;
};

export const AdditionalPayDetailCard = ({
  id,
  label,
  value,
  isLoading,
}: Props) => {
  return (
    <Card px="32" py="16">
      <Stack gap="8">
        <Typography as="label" size="12" weight="medium" color="subtle" id={id}>
          {label}
        </Typography>
        <Typography aria-labelledby={id} as="span" size="14">
          {isLoading ? <Skeleton /> : value || '-'}
        </Typography>
      </Stack>
    </Card>
  );
};
